import { useCallback, useState } from 'react';

const useTextFieldState = (initial) => {
  const [state, setState] = useState(initial);

  const setStateWrapper = useCallback((e) => setState(e?.target?.value || ''), []);

  return [state, setStateWrapper];
};

export default useTextFieldState;
